import { useState } from 'react'

//BL
import EditTransactionForm, {
  EditTransactionFormFields,
} from './EditTransactionForm'

//UI
import { Modal } from '../../../deprecated-components/BaseComponents'
import { parseErrorFromCatch } from '../../../utils/errorHelpers'
import { bulkUpdateUserTransactions } from '../../../actions/adminActions'
import { useAppDispatch } from '../../../utils/typeHelpers'
import { Transaction } from '@/reducers/admin/allTransactions.slice'

interface EditManualTransactionProps {
  disabled: boolean
  onChildBeginLoading: () => void
  onChildEndLoading: () => void
  transaction: Transaction
  onUpdated?: () => void
}

export const useEditManualTransaction = ({
  transaction,
  onChildBeginLoading,
  onChildEndLoading,
  disabled,
  onUpdated = () => undefined,
}: EditManualTransactionProps) => {
  const [open, setOpen] = useState(false)
  const dispatch = useAppDispatch()

  const closeModal = () => setOpen(false)

  function handleError(err: string) {
    alert(err)
  }

  const performSave = async ({
    id,
    amountInCents,
    description,
    date,
  }: EditTransactionFormFields) => {
    try {
      const data = {
        transactionIds: [id],
        amountInCents,
        description,
        date,
      }
      await bulkUpdateUserTransactions(data)(dispatch)
      onUpdated()
      closeModal()
    } catch (err) {
      handleError(parseErrorFromCatch(err))
    }
  }

  const onFormSubmit = async (data: EditTransactionFormFields) => {
    onChildBeginLoading()
    await performSave(data)
    onChildEndLoading()
  }

  const renderModal = () => (
    <Modal closeIcon open={open} onClose={closeModal} size="small">
      <Modal.Header>
        Edit manually created transaction {transaction.description}
      </Modal.Header>
      <Modal.Content>
        <EditTransactionForm
          loading={disabled}
          onSubmit={onFormSubmit}
          transaction={transaction}
        />
      </Modal.Content>
    </Modal>
  )

  return {
    openModal: () => setOpen(true),
    renderModal,
  }
}
